export enum OrderTypes {
  PREORDER_TYPE = 'PREORDER_TYPE',
  ECOMMERCE_TYPE = 'ECOMMERCE_TYPE',
  BRANCH_TYPE = 'BRANCH_TYPE',
  SUMMARY_TYPE = 'SUMMARY_TYPE',
  CUSTOM_TYPE = 'CUSTOM_TYPE',
  SEARCH = 'SEARCH',
}

export const SEARCH = 'SEARCH';
